import { axiosClient, type IResponse } from '~/common/js/axios';
import type { AxiosRequestConfig } from 'axios';

/**
* 关注或取消关注商家
*/
export function followOrBlackMerchant_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/user/followOrBlackMerchant',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 支付方式编辑删除前置校验
*/
export function updateOrDeleteCheck_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/user/updateOrDeleteCheck',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 新增支付方式
*/
export function addOrUpdatePayInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/user/addOrUpdatePayInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 删除当前支付方式
*/
export function deletePayInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/user/deletePayInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface blackOrUnBlackMerchant_POST_res_type {
  /** undefined */ 
  pageInfo: object 
  /** undefined */ 
  followInfoDetails: Array<any> 
}
/**
* 查询个人所有关注商家
*/
export function blackOrUnBlackMerchant_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<blackOrUnBlackMerchant_POST_res_type>>({
    url: '/gw-api/p2p-user/p2p/user/blackOrUnBlackMerchant',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getPayInfo_POST_res_type {
  /** undefined */ 
  pageInfo: object 
  /** undefined */ 
  payInfoDetails: Array<any> 
}
/**
* 查询支付信息
*/
export function getPayInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getPayInfo_POST_res_type>>({
    url: '/gw-api/p2p-user/p2p/user/getPayInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getUserInfo_GET_res_type {
  /** 默认法币区 */
  defaultCurrency: string
  /** 用户cid */ 
  cid: number 
  /** 用户类型，1 用户，2商家 */ 
  type: number 
  /** 用户类型，0普通用户，1 认证商家，2钻石商家， */ 
  level: number 
  /** undefined */ 
  kycLevel: number 
  /** undefined */ 
  followed: boolean 
  /** 用户状态0正常，1下线，2禁止p2p交易 */ 
  state: number 
  /** 昵称 */ 
  nickName: string 
  /** 真实姓名 */ 
  realName: string 
  /** 国家 */ 
  country: string 
  /** 是否已认证商家 */ 
  platformVerified: boolean 
  /** 注册时间 */ 
  registeredTime: string 
  /** id认证状态 */ 
  idVerified: boolean 
  /** 手机认证状态 */ 
  phoneVerified: boolean 
  /** 邮箱认证状态 */ 
  emailVerified: boolean 
  /** 总成交额- usd */ 
  orderQuantity: string 
  /** 总创建订单 */ 
  orderCreate: string 
  /** 总创建买订单 */ 
  orderCreateBuy: string 
  /** 总创建卖订单 */ 
  orderCreateSell: string 
  /** 总完成单数 */ 
  orderComplete: string 
  /** 总完成买单数 */ 
  orderCompleteBuy: string 
  /** 总完成卖单数 */ 
  orderCompleteSell: string 
  /** 总完成率 */ 
  finishRate: string 
  /** 总买单完成率 */ 
  finishRateBuy: string 
  /** 总卖单完成率 */ 
  finishRateSell: string 
  /** 平均付款时间 */ 
  avgPayTime: string 
  /** 平均放币时间 */ 
  avgReleaseTime: string 
  /** 最近30天总成交额- usd */ 
  orderQuantity30day: string 
  /** 最近30天总创建订单 */ 
  orderCreate30day: string 
  /** 最近30天总创建买订单 */ 
  orderCreateBuy30day: string 
  /** 最近30天总创建卖订单 */ 
  orderCreateSell30day: string 
  /** 最近30天总完成单数 */ 
  orderComplete30day: string 
  /** 最近30天总完成买单数 */ 
  orderCompleteBuy30day: string 
  /** 最近30天总完成卖单数 */ 
  orderCompleteSell30day: string 
  /** 最近30天总完成率 */ 
  finishRate30day: string 
  /** 最近30天总买单完成率 */ 
  finishRateBuy30day: string 
  /** 最近30天总卖单完成率 */ 
  finishRateSell30day: string 
  /** 最近30天平均付款时间 */ 
  avgPayTime30day: string 
  /** 最近30天平均放币时间 */ 
  avgReleaseTime30day: string 
  /** 交易完成用户数 */ 
  usersTradeWith: string 
  /** 最近30天交易完成用户数 */ 
  usersTradeWith30day: string 
  /** 关注人数 */ 
  followers: number 
  /** 是否绑定谷歌 */ 
  bindGoogle: boolean 
  /** 背景颜色 */ 
  bgColor: string 
  /** 是否白名单用户 */ 
  isWhiteList: boolean 
  /** 是否可以直接升级为钻石商家 */ 
  isDiamondEnough: boolean 
}
/**
* 查询用户/商家个人主页信息,登录用户
*/
export function getUserInfo_get(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getUserInfo_GET_res_type>>({
    url: '/gw-api/p2p-user/p2p/user/getUserInfo',
    method: 'GET',
    headers: options && options.headers ? options.headers : {},
    params: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface IgetUserMerchantApplyStatus {
  auditStatus: number,
  updateTime: number,
}
/**
* 查询用户/商家个人主页信息,登录用户
*/
export function getUserMerchantApplyStatus_get(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<IgetUserMerchantApplyStatus>>({
    url: '/gw-api/p2p-user/p2p/user/getUserMerchantApplyStatus',
    method: 'GET',
    headers: options && options.headers ? options.headers : {},
    params: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

